import { KeyValuePipe, NgComponentOutlet, NgTemplateOutlet } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { AutofocusDirective } from '../../directives/autofocus';
import { ParagraphizePipe } from '../../pipes';
import { Button } from '../buttons';
import { Checkbox } from '../checkbox';
import { Modal, ModalContent, ModalCta, ModalTitle } from './modal';
import { ButtonInterface, ModalInputTypeEnum, ModalInterface } from './modal-for-root.interface';
import { ModalService } from './modal-service';

@Component({
    selector: 'stby-modal-for-root',
    styleUrl: './modal-for-root.scss',
    templateUrl: './modal-for-root.html',
    imports: [
        Modal,
        ModalTitle,
        ModalContent,
        Checkbox,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatOptionModule,
        AutofocusDirective,
        MatDatepickerModule,
        NgTemplateOutlet,
        ModalCta,
        Button,
        KeyValuePipe,
        ParagraphizePipe,
        TranslateModule,
        NgComponentOutlet,
    ],
})
export class ModalForRoot implements OnInit, OnDestroy {
    private modalService = inject(ModalService);

    modal: ModalInterface = {};
    modalOpen: boolean;
    modalInputTypeEnum = ModalInputTypeEnum;

    private subscriptions: Subscription[] = [];

    ngOnInit() {
        this.subscriptions.push(
            this.modalService.getModalObservable().subscribe((result) => {
                this.modal = result;
            }),
            this.modalService.getModalOpenObservable().subscribe((result) => {
                this.modalOpen = result;
            }),
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    modalOpenChange(isOpen: boolean) {
        if (!isOpen && typeof this.modal.onClose === 'function') {
            this.modal.onClose();
        }

        isOpen ? this.modalService.openModal() : this.modalService.closeModal();
    }

    hasInvalidRelatedInputs(button: ButtonInterface): boolean {
        for (const relatedInput of button.relatedInputs) {
            if (!relatedInput.formControl.valid) return true;
        }
        return false;
    }
}
